import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Trainings from './pages/Trainings';
import Opportunities from './pages/Opportunities';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';
import Corporate from './pages/Corporate';
import Admin from './pages/Admin';
import StudentLogin from './pages/StudentLogin';
import StudentDashboard from './pages/StudentDashboard';
import AlumniFeedback from './pages/AlumniFeedback';
import WallOfFame from './pages/WallOfFame';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/trainings" element={<Trainings />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogDetail />} />
          <Route path="/corporate" element={<Corporate />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/student/login" element={<StudentLogin />} />
          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route path="/alumni-feedback" element={<AlumniFeedback />} />
          <Route path="/wall-of-fame" element={<WallOfFame />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
